module.exports = __webpack_public_path__ + "c733bf864f6071a3e31053e1e0563bef.MP3";